import { render, staticRenderFns } from "./IntSlides.vue?vue&type=template&id=dfba05a8&scoped=true&"
import script from "./IntSlides.vue?vue&type=script&lang=js&"
export * from "./IntSlides.vue?vue&type=script&lang=js&"
import style0 from "./IntSlides.vue?vue&type=style&index=0&id=dfba05a8&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfba05a8",
  null
  
)

export default component.exports